// src/components/Header.js
import React from "react";
import { scrollToId } from "./links";

const Header = () => (
  <nav>
    <a className="logo" href="/">
      AR<span>.</span>
    </a>
    <div className="navl mono">
      <a href="#projects" onClick={scrollToId("projects")}>projects</a>
      <a href="#contact" onClick={scrollToId("contact")}>contact</a>
    </div>
  </nav>
);

export default Header;
